// extracted by mini-css-extract-plugin
module.exports = {"popover":"styles_popover__snSJh","popoverScrollContainer":"styles_popoverScrollContainer__hPL6m","menuItems":"styles_menuItems__wUTqn","animation":"styles_animation__FeVj2"};